import React from "react";
import "../App.css";
import { Designer, Viewer } from "@grapecity/activereports-react";


function Report() {
  const counter = React.useRef(0);
  const [reportStorage, setReportStorage] = React.useState(new Map());

  const onSave = function (info: any) {
    const reportId = info.id || `report${counter.current++}`;
    setReportStorage(new Map(reportStorage.set(reportId, info.definition)));  
    const fileData = JSON.stringify(info.definition);
    console.log(fileData);
    return Promise.resolve({ displayName: reportId });
  };

  const onSaveAs = function (info: any) {
    const reportId = info.id || `report${counter.current++}`;
    setReportStorage(new Map(reportStorage.set(reportId, info.definition)));
    console.log(info.definition);
    return Promise.resolve({ id: reportId, displayName: reportId });
  };


/*   return (
    <div id="viewer-host">
      <Viewer report={{ Uri: 'report_inventory.rdlx-json' }} />
    </div>
  ); */


   return (
    <div id="designer-host">
      <Designer onSave={onSave} onSaveAs={onSaveAs} report={{ id: "report_inventory.rdlx-json", displayName: "Inventory" }}   />
    </div>
  ); 
}

export default Report;